export enum EnvironmentTypes {
  Compliance = 'compliance',
  Demo = 'demo',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
  Test = 'test',
  UserAcceptanceTesting = 'uat',
}
